import type { PointLike } from 'maplibre-gl'

export const bboxAsPointLike = (bbox: any): PointLike => {
  // TODO: Find better workaround for this hotfix
  // Have to use wrong type due to issue in MaplibreGL typescript definition
  return bbox as unknown as PointLike
}
